import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ClassicMeasurementComunicationService {
  private activeMeasurementToolsSubject = new BehaviorSubject<number>(null);

  public activeMeasurementTools$ = this.activeMeasurementToolsSubject.asObservable();

  setActiveTool(toolId: number): void {
    this.activeMeasurementToolsSubject.next(toolId);
  }

  getActiveTool(): number {
    return this.activeMeasurementToolsSubject.getValue();
  }
}
